import type { RootState } from '../store';

export const selectDomains = (state: RootState) => state.domains.domainList;
export const selectSelectableDomains = (state: RootState) =>
  state.domains.domainList.filter((d) => d.isSelectable);
export const selectSelectedDomain = (state: RootState) => state.domains.selectedDomain;
export const selectConnectedDomainCount = (state: RootState) =>
  state.domains.domainList.filter((d) => d.chipStatus === 'connected').length;
export const selectSelectedDomainType = (state: RootState): 'default' | 'custom' => {
  const selected = state.domains.selectedDomain;
  if (!selected) return 'default';
  const match = state.domains.domainList.find((d) => d.domain === selected);
  if (!match || match.chipStatus === 'default') return 'default';
  return 'custom';
};
export const selectDomainsLoading = (state: RootState) => state.domains.loading;
export const selectHasAttemptedFetch = (state: RootState) => state.domains.hasAttemptedFetch;
